export const GET_BLOCK_TIME_STARTED = "GET_BLOCK_TIME_STARTED"
export const GET_BLOCK_TIME_SUCCESS = "GET_BLOCK_TIME_SUCCESS"
export const GET_BLOCK_TIME_FAILURE = "GET_BLOCK_TIME_FAILURE"


export const REMOVE_ERROR_MESSAGE = "REMOVE_ERROR_MESSAGE"
